import { Permission } from "./permissions";
import { ROLE_PERMISSIONS } from "./rolePermissions";
import { parseRole, Role } from "./roles";
export const canViewProject = (roleInput) =>
  hasPermission(roleInput, Permission.PROJECT_VIEW);

export const hasPermission = (
  roleInput,
  permission,
) => {
  const role = typeof roleInput === "string" ? parseRole(roleInput) : roleInput;
  if (!role) return false;
  return ROLE_PERMISSIONS[role].has(permission);
};



export const canCreateProject = (roleInput) =>
  hasPermission(roleInput, Permission.PROJECT_CREATE);

export const canEditProject = (
  roleInput,
  context,
) => {
  if (hasPermission(roleInput, Permission.PROJECT_EDIT)) return true;
  if (hasPermission(roleInput, Permission.PROJECT_EDIT_ASSIGNED)) {
    return Boolean(context?.isAssignedProject);
  }
  return false;
};

export const canDeleteProject = (roleInput) =>
  hasPermission(roleInput, Permission.PROJECT_DELETE);

export const canViewReview = (roleInput) =>
  hasPermission(roleInput, Permission.REVIEW_VIEW);

export const canCreateReview = (roleInput) =>
  hasPermission(roleInput, Permission.REVIEW_CREATE);

export const canEditReview = (
  roleInput,
  context,
) => {
  if (hasPermission(roleInput, Permission.REVIEW_EDIT)) return true;
  if (hasPermission(roleInput, Permission.REVIEW_EDIT_ASSIGNED)) {
    return Boolean(context?.isAssignedProject);
  }
  return false;
};

export const canUploadRisk = (roleInput) =>
  hasPermission(roleInput, Permission.RISK_UPLOAD);

export const canEditSettings = (roleInput) =>
  hasPermission(roleInput, Permission.SETTINGS_EDIT);

export const canApproveUsers = (roleInput) =>
  hasPermission(roleInput, Permission.USER_APPROVAL);

export const getAllowedPermissions = (
  roleInput,
) => {
  const role = typeof roleInput === "string" ? parseRole(roleInput) : roleInput;
  if (!role) return [];
  return [...ROLE_PERMISSIONS[role]];
};